import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	loading: false,
	userInfo: {},
	userSetting: {},
	userToken: null,
	error: null,
	success: false,
	accessToken: '',
	inProgress: { value: false, data: {} },
	isWarningOpen: false,
	sidebarDashboardRoutes: [],
	redirectRoute: null
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		updateUserInfo(state, action) {
			state.userInfo = { ...state.userInfo, ...action.payload };
		},
		updateUserSetting(state, action) {
			state.userSetting = action.payload;
		},
		updateStatus(state, action) {
			state.inProgress = action.payload;
		},
		setAccessToken(state, action) {
			state.accessToken = action.payload;
		},
		resetAuth: () => initialState,
		closeWarning(state) {
			state.isWarningOpen = false;
		},
		openWarning(state) {
			state.isWarningOpen = true;
		},
		updateDashboardRoutes(state, action) {
			state.sidebarDashboardRoutes = action.payload;
		},
		updateRedirectRoute(state, action) {
			state.redirectRoute = action.payload;
		}
	}
	// ExtraReducers: {}
});

export const {
	updateUserInfo,
	updateUserSetting,
	resetAuth,
	updateStatus,
	setAccessToken,
	closeWarning,
	openWarning,
	updateDashboardRoutes,
	updateRedirectRoute
} = authSlice.actions;
export default authSlice.reducer;
